"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDatadogRumInstance = void 0;
/**
 *
 * @returns {undefined|any}
 */
var getDatadogRumInstance = exports.getDatadogRumInstance = function getDatadogRumInstance() {
  return typeof window === 'undefined' ? undefined : window.DD_RUM;
};